var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function stringifyHash(values) {
  var hashKeys = values ? Object.keys(values) : [];
  if (!hashKeys.length) {
    return "";
  }
  return hashKeys.reduce(function(accumulator, param, key) {
    if (param) {
      var encodedValue = encodeURIComponent("".concat(param).concat(values[param] ? "=".concat(values[param]) : ""));
      return "".concat(accumulator).concat(key > 0 ? "&" : "#").concat(encodedValue);
    }
    return accumulator;
  }, "");
}
__name(stringifyHash, "stringifyHash");
export {
  stringifyHash
};
